import {
  defaultFont,
  primaryBoxShadow,
  infoBoxShadow,
  successBoxShadow,
  warningBoxShadow,
  dangerBoxShadow,
  roseBoxShadow,
  whiteColor,
  blackColor,
  primaryColor,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  roseColor,
  grayColor,
  hexToRgb
} from "assets/jss/material-dashboard-react.jsx";

const snackbarContentStyle = {
  root: {
    ...defaultFont,
    flexWrap: "unset",
    position: "relative",
    padding: "20px 15px",
    lineHeight: "20px",
    marginBottom: "20px",
    fontSize: "14px",
    backgroundColor: "white",
    color: grayColor[6],
    borderRadius: "3px",
    boxShadow:
      "0 8px 16px -8px rgba(" +
      hexToRgb(blackColor) +
      ", 0.12), 0 3px 12px 0px rgba(" +
      hexToRgb(blackColor) +
      ", 0.08)"
  },
  top20: {
    top: "20px"
  },
  top40: {
    top: "40px"
  },
  info: {
    backgroundColor: "rgba(" + hexToRgb(infoColor[0]) + ", 0.5)",
    color: grayColor[2],
    ...infoBoxShadow
  },
  success: {
    backgroundColor: "rgba(" + hexToRgb(successColor[0]) + ", 0.5)",
    color: grayColor[2],
    ...successBoxShadow
  },
  warning: {
    backgroundColor: "rgba(" + hexToRgb(warningColor[0]) + ", 0.5)",
    color: grayColor[2],
    ...warningBoxShadow
  },
  danger: {
    backgroundColor: "rgba(" + hexToRgb(dangerColor[0]) + ", 0.5)",
    color: grayColor[2],
    ...dangerBoxShadow
  },
  primary: {
    backgroundColor: "rgba(" + hexToRgb(primaryColor[0]) + ", 0.5)",
    color: grayColor[2],
    ...primaryBoxShadow
  },
  rose: {
    backgroundColor: "rgba(" + hexToRgb(roseColor[0]) + ", 0.5)",
    color: grayColor[2],
    ...roseBoxShadow
  },
  message: {
    padding: "0",
    display: "block",
    maxWidth: "89%"
  },
  close: {
    width: "11px",
    height: "11px"
  },
  iconButton: {
    width: "24px",
    height: "24px",
    padding: "0"
  },
  icon: {
    width: "38px",
    height: "38px",
    display: "block",
    left: "15px",
    position: "absolute",
    marginTop: "-39px",
    fontSize: "20px",
    backgroundColor: whiteColor,
    padding: "9px",
    borderRadius: "50%",
    maxWidth: "38px",
    boxShadow:
      "0 10px 30px -12px rgba(" +
      hexToRgb(blackColor) +
      ", 0.42), 0 4px 25px 0px rgba(" +
      hexToRgb(blackColor) +
      ", 0.12), 0 8px 10px -5px rgba(" +
      hexToRgb(blackColor) +
      ", 0.2)"
  },
  actionButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    marginTop: "12px",
    width: "100%"
  },
  actionButton: {
    flex: 1,
    borderRadius: "4px",
    padding: "8px 12px",
    fontWeight: 600,
    cursor: "pointer",
    backgroundColor: whiteColor,
    color: grayColor[2],
    border: "1px solid " + grayColor[4],
    transition: "all 0.15s ease-in-out",
    textAlign: "center"
  },
  actionButtonInfo: {
    color: infoColor[0],
    border: "1px solid " + infoColor[0],
    backgroundColor: "rgba(" + hexToRgb(infoColor[0]) + ", 0.08)"
  },
  actionButtonSuccess: {
    color: successColor[0],
    border: "1px solid " + successColor[0],
    backgroundColor: "rgba(" + hexToRgb(successColor[0]) + ", 0.08)"
  },
  actionButtonWarning: {
    color: warningColor[0],
    border: "1px solid " + warningColor[0],
    backgroundColor: "rgba(" + hexToRgb(warningColor[0]) + ", 0.08)"
  },
  actionButtonDanger: {
    color: dangerColor[0],
    border: "1px solid " + dangerColor[0],
    backgroundColor: "rgba(" + hexToRgb(dangerColor[0]) + ", 0.08)"
  },
  actionButtonPrimary: {
    color: primaryColor[0],
    border: "1px solid " + primaryColor[0],
    backgroundColor: "rgba(" + hexToRgb(primaryColor[0]) + ", 0.08)"
  },
  infoIcon: {
    color: successColor[3]
  },
  successIcon: {
    color: successColor[3]
  },
  warningIcon: {
    color: warningColor[3]
  },
  dangerIcon: {
    color: dangerColor[3]
  },
  primaryIcon: {
    color: primaryColor[3]
  },
  roseIcon: {
    color: roseColor[3]
  },
  iconMessage: {
    paddingLeft: "50px",
    display: "block"
  }
};

export default snackbarContentStyle;
